import React, { useEffect, useState } from "react";
import "../../styles/styles.css"
import axios from "axios";
import deleteIcon from "../../images/x.png"
import { Buffer } from "buffer";
import { useSelector } from "react-redux";
import Page404 from "app/not-found";


const API_URL = "https://ahuncycle-backend.vercel.app";
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageUsagers = () => {
    const { user } = useSelector((state) => state.user);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        if (user)
        {
            const getUsers = async () => {
            var response;
                try {
                    response = await axiosInstance.get("api/auth");
                    setUsers(response.data);
                } catch (error) {
                    console.log("erreur:"+error);
                }
            }  
            getUsers(); 
        }
      }, []);

    const updateUser = async (user,role) =>
    {
        try 
        {
            const form = new FormData();
            form.append('user',user);
            form.append('role', role);
            const response = await axiosInstance.post("api/auth", form);
            //window.location.href = article.href;
            
            alert("Modification réussie!");
            //console.log("Reponse:"+JSON.stringify(response.data));
        }
        catch (error) 
        {
            console.log("Erreur:", error);
            return;
        }
    };

    const deleteUser = async (user) =>
    {
        try 
        {
            const response = await axiosInstance.delete(`api/auth/${user}`);
            alert("Supression réussie!");
            window.location.reload();
        }
        catch (error) 
        {
            console.log("Erreur:", error);
            return;
        }
    };

    const handleChangeRole = (e) => {
        const select = e.target;
        const user = select.children[select.selectedIndex].id;
        const role = select.value;
        updateUser(user,role);
    }

    const handleDeleteUser = (e) => {
        const button = e.target;
        const user = button.id;
        if (window.confirm("Voulez-vous vraiment supprimer l'usager: " + user + "?"))
            deleteUser(user);
        else
            return;
    }
    if (user)
    return ( 
    {users} && 
        (<div className="centre"><h2 className="inline-block align-middle text-2xl font-semibold md:text-3xl" >Usagers</h2><br></br><br></br>
         <table>
                <tr>
                    <th>Avatar</th>
                    <th>Nom</th>
                    <th>Courriel</th>
                    <th>Rôle</th>
                    <th>Supprimer</th>
                </tr>
        {users.map((user)=>
        (
                <tr>
                    <td align="center"><img
                      src={`data: ${user.img.contentType};base64, ${Buffer.from(user.img.data).toString('base64')}`} 
                      alt="Avatar"
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    /></td>
                    <td><input value={user.name} /></td>
                    <td><input style={{width:"300px"}} value={user.email} /></td>
                    <td>
                        <select  onChange={handleChangeRole}>
                            {user.role==="user" ? <option selected>user</option> : <option id={user._id}>user</option>} 
                            {user.role==="editor" ? <option selected>editor</option> : <option id={user._id}>editor</option>}
                            {user.role==="admin" ? <option selected>admin</option> : <option id={user._id}>admin</option>}
                        </select>
                    </td>
                    <td align="center">
                        <img  id={user._id} style={{width:"30px"}} src={deleteIcon} onClick={handleDeleteUser} />
                    </td>
                </tr>  
        )
        )}
        </table>
        <br></br><br></br>
        </div>));
    else
        return (<Page404 />)
   
}
export default PageUsagers;